import { format } from "date-fns";
import sanitizeHtml from "sanitize-html";

export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  timeout = 600
) => {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
};

export const cleanEmailHtml = (emailHtml) => {
  const sanitized = sanitizeHtml(emailHtml, {
    allowedTags: [
      "p",
      "b",
      "strong",
      "i",
      "em",
      "u",
      "span",
      "a",
      "ul",
      "ol",
      "li",
      "img",
      "table",
      "tr",
      "td",
      "br",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
    ],
    allowedAttributes: {
      "*": ["style"],
      a: ["href"],
      img: ["src", "alt", "width", "height"],
    },
    allowedStyles: {
      "*": {
        // only allow safe inline styles
        color: [/^.*$/],
        "background-color": [/^.*$/],
        "font-size": [/^.*$/],
        "text-align": [/^.*$/],
      },
    },
  });
  return sanitized;
};

export const hasUserPermission = (arr: string[] | undefined, perm: string) => {
  return arr?.includes(perm);
};

export const hasOtherPermissionButGet = (
  arr: string[] | undefined,
  permSection: string
) => {
  const sectionArrLength: number | undefined = arr?.filter(
    (i) => i.includes(permSection) && !i.includes("get")
  )?.length;
  return !!sectionArrLength;
};

export const formatDateString = (date: string) => {
  const splittedDate = date.split(" ");
  const newDate = splittedDate[0]
    .split("/")
    .reverse()
    .join("/")
    .concat(` ${splittedDate[1]}`);
  return newDate;
};

export const handleDownload = (payload, dates = [], extension = "xlsx") => {
  const url = window.URL.createObjectURL(new Blob([payload]));

  const link = document.createElement("a");

  const name = dates?.length
    ? `${format(new Date(dates[0]), "dd/MM/yyyy-hh:mm:ss")}-${format(
        new Date(dates[1]),
        "dd/MM/yyyy-hh:mm:ss"
      )}`
    : `${format(new Date(), "dd/MM/yyyy-hh:mm:ss")}`;
  link.href = url;
  link.setAttribute("download", `Satisfai_${name}.${extension}`);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link?.click();
  link?.parentNode?.removeChild(link);
};

export const getTimeZonedDate = (date) => {
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  const localISOTime = new Date(date - tzoffset).toISOString().slice(0, -1);
  return localISOTime;
};
